import React from 'react';
import { Box } from '@mui/material';
import { badgeContainer, badgeText, badgeIconSvg } from './style';

const origin = window.location.origin;
const isLocal = origin.includes('localhost:') || origin.includes('ngrok-free.app') || origin.includes('127.0.0.1');
const isAcceptanceEnv = origin.includes('acc-emdr-remote') || origin.includes('emdr-remote-acceptance');
const showBadge = isLocal || isAcceptanceEnv;

const FlaskIcon: React.FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" style={badgeIconSvg}>
    <defs>
      <linearGradient id="flask-grad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#4054B2" />
        <stop offset="100%" stopColor="#6EC1E4" />
      </linearGradient>
    </defs>
    <path
      fill="url(#flask-grad)"
      d="M13 2v6.26l5.7 9.11C20 19.41 18.58 22 16.1 22H7.9c-2.48 0-3.9-2.59-2.6-4.63L11 8.26V2h2zm2-2H9v1h6V0zM7.9 20h8.2c.85 0 1.34-.89.89-1.61L13 11.86V4h-2v7.86L7.01 18.39c-.45.72.04 1.61.89 1.61z"
    />
  </svg>
);

const AcceptanceBadge: React.FC = () => {
  if (!showBadge) return null;

  return (
    <Box sx={badgeContainer}>
      <FlaskIcon />
      <Box component="span" sx={badgeText}>
        ACCEPTANCE
      </Box>
    </Box>
  );
};

export default AcceptanceBadge;
